/* Practitioner gate: login prompt, health form popup, return-to-product after login.
   Only acts on products whose variant ids are listed in window.practitionerConfig.variantIds
   (set by snippets/practitioner-modals.liquid for products tagged "practitioner-only"). */
(function () {
  var cfg = window.practitionerConfig || {};
  var RET = 'practitionerReturn';
  var pending = null;
  var formDone = !!cfg.cartFormDone;
  

  function $(id) { return document.getElementById(id); }
  function openDlg(d) { if (d && !d.open) d.showModal(); }
  function closeDlg(d) { if (d && d.open) d.close(); }

  // ---- Return to the product page after login / sign-up ----
  try {
    var r = JSON.parse(localStorage.getItem(RET) || 'null');
    if (r) {
      var p = location.pathname;
      if (Date.now() - r.t > 30 * 60 * 1000 || p === r.path) {
        localStorage.removeItem(RET);
      } else if (cfg.loggedIn && (p === '/' || p.indexOf('/account') === 0)) {
        localStorage.removeItem(RET);
        location.replace(r.path);
      }
    }
  } catch (e) {}

  function saveReturn() {
    try { localStorage.setItem(RET, JSON.stringify({ path: location.pathname + location.search, t: Date.now() })); } catch (e) {}
  }
  function showLogin() {
    saveReturn();
    var rt = encodeURIComponent(location.pathname + location.search);
    var l = $('pr-login-link'), g = $('pr-register-link');
    if (l) l.href = cfg.loginUrl + '?return_url=' + rt;
    if (g) g.href = cfg.registerUrl + '?return_url=' + rt;
    openDlg($('pr-login-dialog'));
  }

  // ---- Gate: Add to cart / Shop now on practitioner products (matched by variant id) ----
  function isPractitionerForm(form) {
    var idEl = form && form.elements && form.elements['id'];
    return !!idEl && (cfg.variantIds || []).indexOf(Number(idEl.value)) > -1;
  }

  function proceed(btn) {
    btn.dataset.prOk = '1';
    btn.click();
  }

    document.addEventListener('click', function (e) {
    if (!(cfg.variantIds && cfg.variantIds.length)) return;
    var btn = e.target.closest('button');
    if (!btn || btn.closest('dialog')) return;

    var label = (btn.name || '') + ' ' + (btn.getAttribute('aria-label') || '');
    var isQty = btn.closest('quantity-selector-component') || /minus|plus|increase|decrease/i.test(label);
    var isAdd = btn.name === 'add' || btn.type === 'submit' || /add-to-cart/.test(btn.className);
    if (isQty || !isAdd) return;

    var form = btn.form || btn.closest('form[action*="/cart/add"]');
    if (!form || !isPractitionerForm(form)) return;
    if (btn.dataset.prOk === '1') { btn.dataset.prOk = ''; return; }

    e.preventDefault();
    e.stopImmediatePropagation();
    if (!cfg.loggedIn) return showLogin();
    if (formDone) return proceed(btn);
    pending = { btn: btn };
    prefill();
    openDlg($('pr-form-dialog'));
  }, true);

//   document.addEventListener('click', function (e) {
//     if (!(cfg.variantIds && cfg.variantIds.length)) return;
//     var btn = e.target.closest('button, a.button, [type="submit"]');
//     if (!btn) return;
//     var form = btn.form || btn.closest('form[action*="/cart/add"]');
//     if (!form || !isPractitionerForm(form)) return;
//     if (btn.dataset.prOk === '1') { btn.dataset.prOk = ''; return; }

//     e.preventDefault();
//     e.stopImmediatePropagation();
//     if (!cfg.loggedIn) return showLogin();
//     if (formDone) return proceed(btn);
//     pending = { btn: btn };
//     prefill();
//     openDlg($('pr-form-dialog'));
//   }, true);

  // ---- Close buttons ----
  document.addEventListener('click', function (e) {
    if (e.target.matches && e.target.matches('[data-pr-close]')) closeDlg(e.target.closest('dialog'));
  });

  // ---- Form ----
  var formEl = $('pr-form');
  if (!formEl) return;

  function prefill() {
    var c = cfg.customer || {};
    if (!$('pr-first').value) $('pr-first').value = c.first || '';
    if (!$('pr-last').value) $('pr-last').value = c.last || '';
    if (!$('pr-email').value) $('pr-email').value = c.email || '';
    if (cfg.productTitle && !$('pr-products').value) $('pr-products').value = cfg.productTitle;
  }
  function radio(n) { var r = document.querySelector('input[name="' + n + '"]:checked'); return r ? r.value : ''; }

  formEl.addEventListener('submit', function (e) {
    e.preventDefault();
    var err = $('pr-error'); err.textContent = '';
    var v = function (id) { return $(id).value.trim(); };
    var d = +v('pr-day'), m = +v('pr-month'), y = +v('pr-year');
    var dob = new Date(y, m - 1, d);
    var anyYes = ['allergies', 'condition', 'pregnant'].some(function (n) { return radio(n) === 'Yes'; });

    if (!v('pr-first') || !v('pr-last') || !/^\S+@\S+\.\S+$/.test(v('pr-email'))) { err.textContent = 'Please enter your name and a valid email.'; return; }
    if (!d || !m || !y || dob.getDate() !== d || dob.getMonth() !== m - 1 || dob > new Date()) { err.textContent = 'This field is required: please enter a valid date of birth.'; return; }
    if (!radio('allergies') || !radio('condition') || !radio('pregnant')) { err.textContent = 'Please answer all health questions.'; return; }
    if (anyYes && !v('pr-details')) { err.textContent = 'Please provide the details of your allergies, condition or medications.'; return; }
    if (!v('pr-products') || !v('pr-initials')) { err.textContent = 'Please complete products requested and initials.'; return; }
    if (!$('pr-declare').checked) { err.textContent = 'Please confirm the declaration.'; return; }

    var attrs = {
      'Practitioner form': 'Completed',
      'Form completed at': new Date().toISOString(),
      'Name': v('pr-first') + ' ' + v('pr-last'),
      'Email (form)': v('pr-email'),
      'Date of birth': d + '/' + m + '/' + y,
      'Allergies or intolerances': radio('allergies'),
      'Medical condition, illness or injury': radio('condition'),
      'Pregnant or breastfeeding': radio('pregnant'),
      'Health details': v('pr-details') || 'N/A',
      'Products requested': v('pr-products'),
      'Initials': v('pr-initials'),
      'Declaration accepted': 'Yes',
      'Newsletter opt-in': $('pr-news').checked ? 'Yes' : 'No'
    };
    var btn = $('pr-submit'); btn.disabled = true;

    fetch('/cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).then(function (res) {
      if (!res.ok) throw new Error('save failed');
      formDone = true;
      if ($('pr-news').checked) {
        var fd = new URLSearchParams({ form_type: 'customer', utf8: '✓', 'contact[email]': v('pr-email'), 'contact[tags]': 'newsletter' });
        fetch('/contact', { method: 'POST', body: fd }).catch(function () {});
      }
      closeDlg($('pr-form-dialog'));
      if (pending) { var b = pending.btn; pending = null; proceed(b); }
    }).catch(function () {
      err.textContent = 'Something went wrong. Please try again.';
    }).then(function () { btn.disabled = false; });
  });
})();
